// extracted by mini-css-extract-plugin
export default {"app":"style_app__DEDpz","content":"style_content__Ghkfs"};